<template>
  <div class="bg-slate-50 rounded-2xl p-4 border border-slate-200" dir="rtl">
    <p class="text-slate-700 text-sm font-medium mb-3">באילו ימים ושעות אתם עובדים?</p>

    <!-- Day toggles -->
    <div class="grid grid-cols-7 gap-1.5 mb-4">
      <button
        v-for="day in days"
        :key="day.value"
        type="button"
        class="aspect-square rounded-lg text-xs font-semibold transition-all border"
        :class="enabledDays[day.value]
          ? 'bg-pink-500 border-pink-500 text-white shadow-sm'
          : 'bg-white border-slate-200 text-slate-500 hover:border-pink-300'"
        @click="toggleDay(day.value)"
      >
        {{ day.shortLabel }}
      </button>
    </div>

    <!-- Time range -->
    <div class="flex items-center gap-2">
      <div class="flex-1">
        <label class="text-xs text-slate-500 mb-1 block">משעה</label>
        <input
          v-model="fromTime"
          type="time"
          class="w-full bg-white border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 focus:outline-none focus:border-pink-400"
          @change="emitUpdate"
        />
      </div>
      <div class="flex-1">
        <label class="text-xs text-slate-500 mb-1 block">עד שעה</label>
        <input
          v-model="toTime"
          type="time"
          class="w-full bg-white border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 focus:outline-none focus:border-pink-400"
          @change="emitUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue';
import { Days, IAvailability } from '@torim-app/types';

const props = defineProps<{
  modelValue: Partial<IAvailability>;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: Partial<IAvailability>];
}>();

const days = [
  { value: Days.SUNDAY, shortLabel: 'א׳' },
  { value: Days.MONDAY, shortLabel: 'ב׳' },
  { value: Days.TUESDAY, shortLabel: 'ג׳' },
  { value: Days.WEDNESDAY, shortLabel: 'ד׳' },
  { value: Days.THURSDAY, shortLabel: 'ה׳' },
  { value: Days.FRIDAY, shortLabel: 'ו׳' },
  { value: Days.SATURDAY, shortLabel: 'ש׳' },
];

// Default: Sun-Thu enabled, Fri/Sat off
const enabledDays = reactive<Record<Days, boolean>>({
  [Days.SUNDAY]: true,
  [Days.MONDAY]: true,
  [Days.TUESDAY]: true,
  [Days.WEDNESDAY]: true,
  [Days.THURSDAY]: true,
  [Days.FRIDAY]: false,
  [Days.SATURDAY]: false,
});

const fromTime = ref('09:00');
const toTime = ref('18:00');

const toggleDay = (day: Days) => {
  enabledDays[day] = !enabledDays[day];
  emitUpdate();
};

const emitUpdate = () => {
  const availability: Partial<IAvailability> = {};
  for (const day of Object.values(Days)) {
    availability[day] = enabledDays[day]
      ? [{ from: fromTime.value, to: toTime.value }]
      : [];
  }
  emit('update:modelValue', availability);
};

// Emit initial state so parent has valid value even without interaction
emitUpdate();
</script>
